var map = {
	"./ba.png": "vqzx",
	"./bb.png": "9f9D",
	"./bc.png": "jWWb",
	"./bk.png": "WOE0",
	"./bn.png": "o4vv",
	"./board.png": "5wBr",
	"./bp.png": "QbRw",
	"./br.png": "B1HT",
	"./dot.png": "f6T9",
	"./nop.png": "didq",
	"./ra.png": "dOxg",
	"./rb.png": "Qzdh",
	"./rc.png": "B6gN",
	"./rk.png": "rDPd",
	"./rn.png": "tai1",
	"./rp.png": "8rST",
	"./rr.png": "dwq1",
	"./selected.png": "o1/X"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "PvXa";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*$
// module id = PvXa
// module chunks = 1